export const localization = {
  en: {
    topBannerTitle: 'Delivering the best-quality care for every need.',
    topSubBannerTitle:
      'We focus on many different areas of pediatric health, so we can offer the specialty care services your child deserves.',
    topButton: 'Explore Specialty Services',
    hello: 'Hello',
    switchPatient: 'Switch Patient',
    viewingHealthRecordFor: 'Viewing health record of '
  },
  es: {
    topBannerTitle:
      'Brindando la mejor atención de calidad para cada necesidad.',
    topSubBannerTitle:
      'Nos enfocamos en muchas áreas diferentes de la salud pediátrica, para poder ofrecer los servicios de atención especializada que su hijo merece.',
    topButton: 'Explorar Servicios Especializados',
    hello: 'Hola',
    switchPatient: 'Cambiar De Paciente',
    viewingHealthRecordFor: 'Exploración del expediente clínico de '
  },
  /* eslint-disable no-secrets/no-secrets */
  keyMapping: {
    hello: 'UFD_Hello_Label',
    viewingHealthRecordFor: 'UFD_Viewing_Health_Record',
    topBannerTitle: '',
    topSubBannerTitle: '',
    topButton: '',
    switchPatient: 'UFD_Switch_Patient_Mobile'
  }
  /* eslint-disable no-secrets/no-secrets */
}
